<div *ngIf="!listDisplay">
  <div *ngIf="!display">
    <div class="content-wrapper question-type-checkbox">
      <div class="btn-wrapper">
        <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
          <span>{{'questions.typeOfQuestions.multipleResponse.btnBack' | translate}}</span>
        </button>
        <span class="spacer"></span>
        <button [disabled]="saveDisable || (addQuestionForm.invalid || addOptionNew.length < 2)" mat-flat-button color="" class="btn-primary" aria-label="Save" (click)='saveQuestion()'>
          <span>{{'questions.typeOfQuestions.multipleResponse.btnSave' | translate}}</span>
        </button>
      </div>
      <div class="row text-msg" *ngIf="saveDataValidation==true">
        <span>Please fill the form</span>

      </div>
      <div class="filter-section">
        <div class="body-section title">
          <mat-icon>library_add</mat-icon> &nbsp;
          <span>{{'questions.typeOfQuestions.multipleResponse.title' | translate}}</span>
        </div>
        <form [formGroup]="addQuestionForm">
          <div class="body-section-2">
            <label class="que-label">{{'questions.typeOfQuestions.multipleResponse.labelQuest' | translate}}</label>
            <!-- <ckeditor formControlName="question" data="Enter here..." [config]="ckeditorConfig" [ngClass]="{'ckeditor-loading': isCkeditorLoading}"
              (ready)="onCkeditorReady()"></ckeditor> -->
              <!-- CKEditor version 5 -->
              <ckeditor #myEditor formControlName="question" [editor]="Editor" (ready)="onReady($event)" (click)="onClick(true)"></ckeditor>
              <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
          </div>
        </form>
      </div>
      <div *ngIf="showQuestionError" class="text-msg">
        <span>{{'questions.typeOfQuestions.multipleResponse.errorQuestion' | translate}}</span>
      </div>
      <div class="filter-section">
        <div class="body-section title">
          <div class="">
            <span>{{'questions.typeOfQuestions.multipleResponse.labelOption' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="body-section-2">
        <form [formGroup]="addOptionForm">
          <!-- <ckeditor formControlName="option" [config]="ckeditorConfig"></ckeditor> -->
          <!-- CKEditor version 5 -->
          <ckeditor #myEditor1 formControlName="option" [editor]="Editor" (ready)="onReadyOption($event)"></ckeditor>
        </form>
        <div *ngIf="errorMessageOption" class="alert alert-danger">{{ errorMessageOption }}</div>
      </div>
      <div *ngIf="!addOptions" class="text-msg">
        <span>{{'questions.typeOfQuestions.multipleResponse.errorOption' | translate}}</span>
      </div>
      <div class="btn-container">
        <button mat-flat-button color="" class="btn-warn" (click)='addOption()'>
          {{'questions.typeOfQuestions.multipleResponse.btnAddOptions' | translate}}
        </button>
      </div>
      <div *ngIf="editMode==false">
        <div *ngIf="questionscoreF==true && scoringTypeId == ScoringTypeEnum.OnQuestion">
          <label class="Questions-score">{{'questions.typeOfQuestions.multipleResponse.labelQuestScore' | translate}}</label>
          <input min="0" value="newEvent" [(ngModel)]="newEvent" class="form-control scoreInput" readonly (keypress)="keyPressNumbers($event)">
        </div>

        <div class="score-wrapper " cdkDropList (cdkDropListDropped)="dragAndDrop($event)">
          <label class="mrg-top"
            *ngIf="questionscoreF==true && scoringTypeId != ScoringTypeEnum.On180360Degree">{{'questions.typeOfQuestions.standard.labelSetScore' |
            translate}}</label>
          <label class="mrg-top"
            *ngIf="questionscoreF==true && scoringTypeId == ScoringTypeEnum.On180360Degree">{{'questions.typeOfQuestions.standard.labelStyle' |
            translate}}</label>
          <div class="add-option" *ngFor="let o of addOptionNew; let i = index" cdkDrag>
            <div class="input-class-container" *ngIf="scoringTypeId != ScoringTypeEnum.On180360Degree">
              <mat-checkbox (change)="onCheckRadioOption(o,$event)" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion"> </mat-checkbox>
              <input type="number" class="form-control"
              min="0" max="9999" step=".01"
              value="" [(ngModel)]="o.correctPoints" (keypress)="omit_special_char($event)"
              (change)="addScore(o)" (input)="validateInput($event, o, 'options')">


              <!-- <input type="number" min="0" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}"
                oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                value="" [(ngModel)]="o.correctPoints" (change)="addScore(o)" class="form-control "> -->
              <ng-component class="optionss" [innerHTML]="o?.answerDescription?.description | sanitizeHtml">
              </ng-component>
              <div class="drag-box" *cdkDragPreview>
                <span [innerHtml]="o?.answerDescription?.description"></span>
              </div>
            </div>

            <div class="input-class-container " *ngIf="scoringTypeId == ScoringTypeEnum.On180360Degree">
              <div class="row">
                <div class="col-md-6">
                  <ng-component class="optionss" [innerHTML]="o?.answerDescription?.description | sanitizeHtml">
                  </ng-component>
                </div>
                <div class="col-md-6" style="width: 20%;">
                  <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model=""
                    (change)="onSelectStyle($event, o?.optionId)">
                    <option>
                      {{'questions.typeOfQuestions.multipleResponse.optionSelect' | translate}}
                    </option>
                    <option *ngFor="let option of StyleList" [value]="option?.styleId">
                      {{option?.styleName}}
                    </option>
                  </select>
                  <!-- <ng-multiselect-dropdown
                    [settings]="StyleDropdownSettings"
                    [data]="StyleList"
                    (onSelect)="onSelectStyle($event, o?.answerDescription?.description)"
                    (onDeSelect)="onStyleDeSelect($event, o?.answerDescription?.description)">
                  </ng-multiselect-dropdown> -->
                </div>
              </div>
              <div class="drag-box" *cdkDragPreview>
                <span [innerHtml]="o?.answerDescription?.description"></span>
              </div>
            </div>
            <button mat-icon-button matTooltip="{{'questions.typeOfQuestions.multipleResponse.addOptions.toolTip.edit' | translate}}"
             (click)="openDialog(o?.answerDescription?.description, o?.optionId, i)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button matTooltip="{{'questions.typeOfQuestions.multipleResponse.addOptions.toolTip.delete' | translate}}"
             [ngClass]="{'disableIcon': roleSer.accessData? !roleSer.accessData.deleteAllowed:true}"
             (click)="deleteOption(i)">
              <mat-icon>delete_outline</mat-icon>
            </button>
            <!-- <button mat-icon-button class="action-button" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog(o?.answerDescription?.description, o?.optionId)">
                <mat-icon>edit</mat-icon>
                <span>
                  {{'questions.typeOfQuestions.multipleResponse.addOptions.toolTip.edit' | translate}}
                </span>
              </button>
              <button mat-menu-item [disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true" (click)="deleteOption(i)">
                <mat-icon>delete_outline</mat-icon>
                <span>
                  {{'questions.typeOfQuestions.multipleResponse.addOptions.toolTip.delete' | translate}}
                </span>
              </button>
            </mat-menu> -->
          </div>
        </div>

      </div>
      <div *ngIf="editMode==true">
        <div *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
          <label class="Questions-score">{{'questions.typeOfQuestions.multipleResponse.labelQuestScore' | translate}}</label>
          <input type="number" min="0" value="newEvent" [(ngModel)]="newEvent" class="form-control scoreInput" readonly
            (keypress)="keyPressNumbers($event)">
        </div>
        <div class="score-wrapper " cdkDropList (cdkDropListDropped)="dragAndDrop($event)">
          <label class="mrg-top"
            *ngIf="questionscoreF==true && scoringTypeId != ScoringTypeEnum.On180360Degree">{{'questions.typeOfQuestions.standard.labelSetScore' |
            translate}}</label>
          <label class="mrg-top"
            *ngIf="questionscoreF==true && scoringTypeId == ScoringTypeEnum.On180360Degree">{{'questions.typeOfQuestions.standard.labelStyle' |
            translate}}</label>
          <div class="add-option" *ngFor="let o of fetchEditOption; let i = index" cdkDrag>
            <div class="input-class-container" *ngIf="scoringTypeId != ScoringTypeEnum.On180360Degree">
              <mat-checkbox [value]="o" id="o{{i}}" name="o" (change)="onCheckRadioOption(o,$event)" [checked]="o?.answerValid==true"
                *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
              </mat-checkbox>
              <input type="number" class="form-control"
              min="0" max="9999" step=".01"
              value="" [(ngModel)]="o.correctPoints"
              (change)="addScore(o)" (input)="validateInput($event, o, 'options')" (keypress)="omit_special_char($event)">

              <!-- <input type="number" min="0" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}"
                oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                value="" [(ngModel)]="o.correctPoints" class="form-control " (change)="addScore(o)"> -->
              <ng-component class="optionss" [innerHTML]="o?.answerDescription?.description | sanitizeHtml">
              </ng-component>
              <div class="drag-box" *cdkDragPreview>
                <span [innerHtml]="o?.answerDescription?.description"></span>
              </div>
            </div>

            <div class="input-class-container " *ngIf="scoringTypeId == ScoringTypeEnum.On180360Degree">
              <div class="row">
                <div class="col-md-6">
                  <ng-component class="optionss" [innerHTML]="o?.answerDescription?.description | sanitizeHtml">
                  </ng-component>
                </div>
                <div class="col-md-6" style="width: 20%;">
                  <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid" [(ngModel)]="o.styleid"
                    ng-reflect-model="" (change)="onSelectStyle($event, o?.answerDescription?.description)">
                    <option>select</option>
                    <option *ngFor="let option of StyleList" [value]="option?.styleId">
                      {{option?.styleName}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="drag-box" *cdkDragPreview>
                <span [innerHtml]="o?.answerDescription?.description"></span>
              </div>
            </div>
            <button mat-icon-button matTooltip="{{'questions.typeOfQuestions.multipleResponse.addOptions.toolTip.edit' | translate}}"
            (click)="openDialog(o?.answerDescription?.description, o?.optionId, i)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button matTooltip="{{'questions.typeOfQuestions.multipleResponse.addOptions.toolTip.delete' | translate}}"
            [ngClass]="{'disableIcon': roleSer.accessData? !roleSer.accessData.deleteAllowed:true}" (click)="deleteEditOption(i,o)">
              <mat-icon>delete_outline</mat-icon>
            </button>
            <!-- <button mat-icon-button class="action-button" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog(o?.answerDescription?.description, o?.optionId)">
                <mat-icon>edit</mat-icon>
                <span>{{'questions.typeOfQuestions.multipleResponse.addOptions.toolTip.edit' | translate}}</span>
              </button>
              <button mat-menu-item [disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true" (click)="deleteEditOption(i,o)">
                <mat-icon>delete_outline</mat-icon>
                <span>{{'questions.typeOfQuestions.multipleResponse.addOptions.toolTip.delete' | translate}}</span>
              </button>
            </mat-menu> -->

          </div>
        </div>
      </div>
      <div class="exp-panel">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'questions.typeOfQuestions.multipleResponse.accordian.title' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="userForm">
              <div class="container-fluid  body-section-2">
                <div class="row" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                  <div class="col-md-2">
                    <div class="scoring-check">
                      <mat-checkbox name="autoscoring" formControlName="autoscore" [checked]="autoscoring"
                        [disabled]="true"><b>{{'questions.typeOfQuestions.multipleResponse.accordian.checkbox' | translate}}</b>
                      </mat-checkbox>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="scoring-check">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                    <div class="form-label">
                      <label>{{'questions.typeOfQuestions.multipleResponse.accordian.selectOptions.option1.label' | translate}}</label>
                    </div>
                  </div>
                  <div class="col-md-3" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                    <mat-form-field class="scoring-type" appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                      [floatLabel]="floatLabelControl.value">
                      <mat-select formControlName="scoringTypeMatch" [(value)]="getscoringtype">
                        <mat-option [value]="option.id == 1 ? 'true' : 'false'" *ngFor="let option of QuestionScoringType">{{option.title}}</mat-option>

                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-2 answers-label">
                    <div class="form-label">
                      <label>{{'questions.typeOfQuestions.multipleResponse.accordian.selectOptions.option2.label' | translate}}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field class="scoring-type" appearance="fill">
                      <mat-select formControlName="questionDisplay" [(value)]="getQuestionDisplay">
                        <mat-option [value]="option.title" *ngFor="let option of QuestionOrientation">{{option.title}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                  <!-- <div class="col-md-2">
                    <div class="form-label score-labels">
                      <label>{{'questions.typeOfQuestions.multipleResponse.accordian.selectOptions.option3' | translate}}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <input min="0" [attr.disabled]="true" type="number" formControlName="penaltyPoint" class="form-control penalty-points"
                      type="number" min="0" max="9999" onkeypress="if(this.value.length == 4 ) return false;">
                  </div> -->

                  <div class="col-md-2">
                    <div class="form-label score-labels">
                      <label required>{{'questions.typeOfQuestions.multipleResponse.accordian.selectOptions.option4.label' | translate}} </label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <input type="number" class="form-control penalty-points"
                    min="0" max="9999" step=".01" formControlName="minimumScoreIfAttempt"
                    [ngClass]="{ 'is-invalid': submitted && f.minimumScoreIfAttempt.errors }"
                    (input)="validateInput($event, 0, 'minimumScore')" (keypress)="omit_special_char($event)">

                    <!-- <input type="number" min="0" max="9999" onkeypress="if(this.value.length == 4 ) return false;"
                      formControlName="minimumScoreIfAttempt" class="form-control penalty-points"
                      [ngClass]="{ 'is-invalid': submitted && f.minimumScoreIfAttempt.errors }"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"> -->
                    <div *ngIf=" f.minimumScoreIfAttempt.errors" class="alert alert-danger w-75 zero">
                      <div *ngIf="f.minimumScoreIfAttempt.errors.required">
                        {{'questions.typeOfQuestions.multipleResponse.accordian.selectOptions.option4.errorMsg1' | translate}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>

  <div *ngIf="display">
    <app-choose-question-type></app-choose-question-type>
  </div>
</div>

<div *ngIf="listDisplay">
  <app-question-list></app-question-list>
</div>
